import { ApiClient } from './client';
import type { RankingEntry } from '@/types/gamification.types';

export const rankingsAPI = {
  // Sin `limit` → todos los alumnos de la empresa (pestaña Empresa).
  // Con `limit` → top N (p. ej. widget del dashboard).
  getCompanyRanking: (companyId: string, limit?: number): Promise<RankingEntry[]> =>
    ApiClient.get<RankingEntry[]>(
      limit != null
        ? `/rankings?companyId=${companyId}&limit=${limit}`
        : `/rankings?companyId=${companyId}`
    ),

  // Sin `limit` → el backend devuelve TODOS los alumnos (pestaña Global).
  // Con `limit` → top N (p. ej. widget del dashboard, cálculo de puesto propio).
  getGlobalRanking: (limit?: number): Promise<RankingEntry[]> =>
    ApiClient.get<RankingEntry[]>(limit != null ? `/rankings?limit=${limit}` : `/rankings`),
};
